import isEqual from 'hs-lodash/isEqual';
import { useCallback, useMemo, useRef, useState } from 'react';
const isUpdater = next => typeof next === 'function';
const identity = state => state;
export const useSubscribableState = initialState => {
  const stateRef = useRef(initialState);
  const [state, setState] = useState(initialState);
  const subscribers = useRef(new Set([]));
  const lenses = useRef(new WeakMap());
  const handleChange = useCallback(next => {
    setState(currentState => {
      const nextState = isUpdater(next) ? Object.assign({}, next(currentState)) : next;
      stateRef.current = nextState;
      subscribers.current.forEach(subscriber => {
        const lens = lenses.current.get(subscriber) || identity;
        const currentStateSlice = lens(currentState);
        const nextStateSlice = lens(nextState);
        if (!isEqual(currentStateSlice, nextStateSlice)) {
          subscriber(nextStateSlice);
        }
      });
      return nextState;
    });
  }, []);
  const subscribe = useCallback((subscriber, lens) => {
    subscribers.current.add(subscriber);
    lenses.current.set(subscriber, lens || identity);
    return () => {
      subscribers.current.delete(subscriber);
      lenses.current.delete(subscriber);
    };
  }, []);
  return useMemo(() => [state, handleChange, subscribe, stateRef], [handleChange, state, subscribe, stateRef]);
};